import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { CandidateData } from '@core/tellent-assistant-types';
import { AppKind } from '@core/tellent-types';
import { BadgeComponent } from '@core/user-interface-legacy';

import { injectAssistantEntityUrl } from '../../assistant-entity-url';
import { ListCardComponent } from '../../list-card/list-card.component';
import { ListRowPersonComponent } from '../../rows/list-row-person.component';

@Component({
  selector: 'rt-list-item-candidate',
  imports: [BadgeComponent, ListCardComponent, ListRowPersonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-candidate.component.html',
  styleUrl: './list-item-candidate.component.less',
})
export class ListItemCandidateComponent {
  private readonly entityUrl = injectAssistantEntityUrl();

  protected readonly url = computed(() =>
    this.entityUrl(AppKind.Recruitee, {
      id: 'candidate',
      params: { candidateId: this.data().id },
    }),
  );

  public readonly data = input.required<CandidateData>();
}
